import { Box, Button, Grid, Typography } from '@mui/material'
import moment from 'moment'
import React, { useState } from 'react'
import AnDateTimePicker from '../../../../../../components/DateTime/DateTimePicker'
import Indication from './Indication'
import Consent from './Consent'
import AgentsUsed from './AgentsUsed'
import EstimatedWeight from './EstimatedWeight'
import PreOxygenation from './PreOxygenation'
import PreSedationSAT from './PreSedationSAT'
import PostSedationSAT from './PostSedationSAT'
import AdverseReaction from './AdverseReaction'
import BigModal from '../../../../../../components/Modals/BigModal'
import SedationChecklist from './Checklist'
import LaryngospasmActions from './LarynospasmActions'
import EmergenceActions from './EmergenceActions'

const Sedation = ({ submitModule }) => {
  const [moduleValues, setModuleValues] = useState({
    dateTime: moment(),
  })

  const [showChecklist, setShowChecklist] = useState(false)
  const [showLaryngospasmActions, setShowLaryngospasmActions] = useState(false)
  const [showEmergenceActions, setShowEmergenceActions] = useState(false)

  return (
    <Box padding={1}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} lg={6}>
          <Typography variant="title2">Sedation</Typography>
        </Grid>
        <Grid item xs={12} lg={6}>
          <AnDateTimePicker
            date={moduleValues.dateTime}
            fullWidth
            onChange={(newDate) =>
              setModuleValues((prev) => ({ ...prev, dateTime: newDate }))
            }
            size="small"
          />
        </Grid>
        <Grid item xs={12} lg={4}>
          <Button
            color="anPurple"
            fullWidth
            onClick={() => setShowChecklist(true)}
            size="small"
            variant="contained"
          >
            Show Checklist
          </Button>
        </Grid>
        <Grid item xs={12} lg={4}>
          <Button
            color="error"
            fullWidth
            onClick={() => setShowLaryngospasmActions(true)}
            size="small"
            variant="contained"
          >
            Laryngospasm
          </Button>
        </Grid>
        <Grid item xs={12} lg={4}>
          <Button
            color="error"
            fullWidth
            onClick={() => setShowEmergenceActions(true)}
            size="small"
            variant="contained"
          >
            Emergence
          </Button>
        </Grid>
        <Indication
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />

        <AgentsUsed
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <Consent
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <EstimatedWeight
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <PreOxygenation
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <PreSedationSAT
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <PostSedationSAT
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <AdverseReaction
          moduleValues={moduleValues}
          setModuleValues={setModuleValues}
        />
        <Grid item xs={12}>
          <Button
            variant="contained"
            color="success"
            fullWidth
            onClick={() => submitModule('Sedation', moduleValues)}
          >
            Submit
          </Button>
        </Grid>
      </Grid>
      <SedationChecklist
        open={showChecklist}
        onClose={() => setShowChecklist(false)}
        submitModule={submitModule}
      />
      <LaryngospasmActions
        open={showLaryngospasmActions}
        onClose={() => setShowLaryngospasmActions(false)}
        submitModule={submitModule}
      />
      <EmergenceActions
        open={showEmergenceActions}
        onClose={() => setShowEmergenceActions(false)}
        submitModule={submitModule}
      />
    </Box>
  )
}

export default Sedation
